import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useToast } from '../../hooks/use-toast';
import { crmTerritorialAPI } from '../../services/api';
import { Loader2 } from 'lucide-react';

// P3J — Alta manual de un prospecto territorial (contacto + oportunidad inicial).
export const ProspectoNuevo = ({ asesores, seccionActual, onCerrar, onGuardado }) => {
  const { toast } = useToast();
  const [cat, setCat] = useState({ tipos_contacto: [], operaciones: [] });
  const [f, setF] = useState({ nombre: '', apellidos: '', email: '', telefono: '',
    asesor_id: '', tipo_contacto: 'comprador', operacion: 'venta', monto_estimado: '',
    ciudad: '', fuente: '', notas: '' });
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    crmTerritorialAPI.catalogosProspecto().then(setCat).catch(() => {});
  }, []);

  const disponibles = seccionActual
    ? asesores.filter((a) => a.seccion_id === seccionActual) : asesores;
  const listo = f.nombre.trim().length >= 2 && f.apellidos.trim().length >= 2 && f.asesor_id
    && (f.email.trim() || f.telefono.replace(/\D/g, '').length >= 10);

  const guardar = async () => {
    setEnviando(true);
    try {
      const r = await crmTerritorialAPI.capturarProspecto({
        nombre: f.nombre.trim(),
        apellidos: f.apellidos.trim(),
        asesor_id: f.asesor_id,
        email: f.email.trim() || null,
        telefono: f.telefono.trim() || null,
        tipo_contacto: f.tipo_contacto,
        operacion: f.operacion,
        monto_estimado: f.monto_estimado ? Number(f.monto_estimado) : null,
        ciudad: f.ciudad.trim() || null,
        fuente: f.fuente.trim() || null,
        notas: f.notas.trim() || null,
      });
      toast({ title: 'Prospecto capturado',
        description: `${r.nombre} asignado a ${r.asesor.nombre} en ${r.seccion}.` });
      onGuardado();
      onCerrar();
    } catch (e) {
      toast({ title: 'Captura rechazada', description: e.message, variant: 'destructive' });
    } finally { setEnviando(false); }
  };

  const campo = (k, ph, extra = {}) => (
    <Input value={f[k]} placeholder={ph} data-testid={`prospecto-${k}`}
           onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />
  );

  return (
    <Dialog open onOpenChange={onCerrar}>
      <DialogContent className="max-w-2xl" data-testid="prospecto-nuevo-dialog">
        <DialogHeader><DialogTitle>Nuevo prospecto territorial</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {campo('nombre', 'Nombre')}
            {campo('apellidos', 'Apellidos')}
            {campo('email', 'Correo (opcional si hay teléfono)')}
            {campo('telefono', 'Teléfono a 10 dígitos')}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <select value={f.asesor_id} onChange={(e) => setF({ ...f, asesor_id: e.target.value })}
                    className="border rounded-lg px-3 py-2 text-sm bg-white"
                    data-testid="prospecto-asesor">
              <option value="">Asignar a…</option>
              {disponibles.map((a) => (
                <option key={a.asesor_id} value={a.asesor_id}>{a.nombre}</option>
              ))}
            </select>
            <select value={f.tipo_contacto}
                    onChange={(e) => setF({ ...f, tipo_contacto: e.target.value })}
                    className="border rounded-lg px-3 py-2 text-sm bg-white"
                    data-testid="prospecto-tipo">
              {cat.tipos_contacto.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
            <select value={f.operacion} onChange={(e) => setF({ ...f, operacion: e.target.value })}
                    className="border rounded-lg px-3 py-2 text-sm bg-white"
                    data-testid="prospecto-operacion">
              {cat.operaciones.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {campo('monto_estimado', 'Monto estimado', { type: 'number', min: '0' })}
            {campo('ciudad', 'Ciudad')}
            {campo('fuente', 'Fuente (referido, evento…)')}
          </div>
          {campo('notas', 'Notas de la primera conversación')}
          <Button onClick={guardar} disabled={!listo || enviando}
                  data-testid="prospecto-guardar-btn">
            {enviando && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Capturar prospecto
          </Button>
          <p className="text-xs text-gray-500">
            Se crea el contacto y su oportunidad en etapa <strong>prospecto</strong> a nombre del
            asesor elegido, con nota de alta en la bitácora. Se rechaza si el correo o el teléfono ya
            existen; si están en otra sección no se muestra ningún dato de ese territorio. Sin
            correos ni mensajes externos.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProspectoNuevo;
